module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-SemiBold-01b6dc52b76863e5371cea0479d1ea72.woff";